import React from 'react';
import globalStyles from '../../styles';
import Panel from './Panel';
import BrokerList from '../../components/Panel/Brokers/BrokerList';
import {Link} from 'react-router';
import urlBase from '../../url-base';


  const styles = {
    tituloPagina: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    breadcrumb: {
      fontSize: 12,
      float: 'right'
    }
  };

const BrokersPage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link to={urlBase.client + 'panel'}>Home</Link>
          &nbsp;>&nbsp;
          <Link style={{color:'#505050'}} to={urlBase.client + "panel/brokers"}>
            Corretoras
          </Link>
        </div>

        <h3 style={globalStyles.navigation}>
          Lista de
          <span style={styles.tituloPagina}> Corretoras</span>
        </h3>

        <BrokerList />

      </div>
    </Panel>

  );
};

export default BrokersPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/BrokersPage.js
 **/